import { jsx as _jsx } from "react/jsx-runtime";
import { VendorsItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = (props) => _jsx(VendorsItem, { isAdd: true, ...props });
export default Add;
